import { ESTADOS } from './';
import { TRAMITES } from './';
import { guardaService } from '../_services';
import { router } from '../_helpers';

let service = guardaService;

function getImageSubDomain(item) {
    if (!item) {
        return '';
    }

    const clienteAbrv = item.cliente && item.cliente.abrv
        ? String(item.cliente.abrv).trim()
        : '';
    const codigo = item.codigo != null
        ? String(item.codigo).trim()
        : '';

    if (!clienteAbrv || !codigo) {
        return '';
    }

    return clienteAbrv + codigo;
}

/** Campos derivados solo de `item` (misma fuente que getImageSubDomain). El API puede armar SubDomain si viene vacío. */
function guardaImageClienteCodigoFromItem(item) {
    const clienteAbrv =
        item && item.cliente && item.cliente.abrv ? String(item.cliente.abrv).trim() : '';
    const codigo =
        item && item.codigo != null ? String(item.codigo).trim() : '';
    return { clienteAbrv, codigo };
}

function canFetchGuardaImageApi(payload) {
    if (!payload || !payload.folder) {
        return false;
    }
    if (!payload.domain) {
        return false;
    }
    return !!(
        payload.subDomain ||
        (payload.clienteAbrv && payload.codigo)
    );
}

/** domain + subDomain desde ítem; clienteAbrv/codigo desde el mismo ítem para el API (Guarda). */
function buildImageApiPayload(item, folder) {
    const { clienteAbrv, codigo } = guardaImageClienteCodigoFromItem(item);
    return {
        system: 1,
        domain: item.nombre,
        subDomain: getImageSubDomain(item),
        folder,
        clienteAbrv,
        codigo
    };
}

function getRequestErrorMessage(error, notFoundMessage) {
    if (error.response && error.response.status === 404) {
        return notFoundMessage;
    }

    if (error.response && error.response.data) {
        return error.response.data;
    }

    return error.message;
}

function isGuardaDestinoTramite(tramiteId, tramites) {
    return tramiteId == tramites.INICIAGUARDA || tramiteId == tramites.INGRESOGUARDA;
}

function setGuardaDestino(tramite, guarda, depositos) {
    if (tramite.depositoId == null || tramite.depositoId == 0) {
        tramite.deposito = guarda.deposito;
        tramite.depositoId = guarda.depositoId;
        tramite.puestoId = guarda.puestoId;
        return;
    }

    if (!tramite.deposito || !tramite.deposito.nombre) {
        tramite.deposito = (depositos || []).find(x => x.id == tramite.depositoId);
    }

    if (!tramite.deposito && guarda.depositoId == tramite.depositoId) {
        tramite.deposito = guarda.deposito;
    }
}

const state = {
    item: {},                       //
    showImages: true,               //    
    id: 0,                          //
    modificado: false,              //
    thumbnails: [],                 //
    newThumbnails: [],              //
    docThumbnails: [],              //
    newDocThumbnails: [],           //
    privThumbnails: [],             //
    newPrivThumbnails: [],          //
    filePath: '',                   //
    dropBoxPath: '',                //
    dropBoxDocPath: '',             //
    dropBoxPrivPath: '',            //
    emails: {},                     //

    file: {},
    uploadFilePath: '',
    items: [],
    // variables para hacer el upload a dropbox
    uploadParams: {},

    all: {},
    itemCompact: {},
    itemResult: null,
    tramite: {},
    marcaModelo: '',
    casosFinalizados: false,
    usuarioActual: false,
    progress: false,
    processed: false,
    error: false,
    dialog: false,
    borraDialog: false,
    dialogTramite: false,
    todosTramitesCompletados: false,
    deflt: {
        id: 0,
        nombre: '',
        abrv: '',
        empresa: {
            nombre: '',
            abrv: '',
        },
        clienteId: null,
        cliente: { nombre: '', id: null },
        marcaModelo: '',
        codigo: '',
        siniestro: '',
        estadoId: 12, //ESTADOS.SIN_INICIAR,
        estado: { nombre: 'SIN INICIAR', id: 12 },
        modeloValorId: null,
        modeloValor: { marcaId: null, marca: '', modeloId: null, modelo: '', tipoId: null, tipo: '' },
        marcaId: null,
        marca: { nombre: '', id: null },
        modeloId: null,
        modelo: { nombre: '', id: null },
        anio: null,
        dropboxLink: '',
        motor: '',
        chasis: '',
        color: '',
        applicationUserId: null,
        applicationUser: { username: '', id: null, email: '' },
        guardaTramite: [],
        guardaAlerta: [],
        deposito: { nombre: '', id: null },
        depositoId: null,
        puestoId: null,
        borrado: false,
    },

    defltTramite: {
        id: 0,
        tramiteId: 0,
        fInicio: null,
        fCierre: null,
        descripcion: '',
        usuarioId: 0,
        completado: false,
        numeroComprobante: '',
        fechaComprobante: null,
        importeComprobante: null,
        depositoId: null,
        puestoId: null,
        deposito: { nombre: '', id: null },

        orden: 0,
        borrado: false,
        nuevoTramite: false,
    }

};

const actions = {
    async initialize({ dispatch, commit }) {
        await dispatch('estado/getAllAsync', null, { root: true });
        dispatch('modelovalortipo/getAll', null, { root: true });
        //dispatch('modelovalor/getAll', null, { root: true });
        dispatch('tramite/getAll', null, { root: true });
        dispatch('marca/getAll', null, { root: true });
        dispatch('modelo/getAll', null, { root: true });
        dispatch('deposito/getAll', null, { root: true });
        dispatch('cliente/getAll', null, { root: true });
        commit('setItem', JSON.parse(JSON.stringify(state.deflt)));
    },

    editItem({ dispatch, commit, state, rootState }, itm) {
        if (state.dialog) {
            commit('setDialog', false);
            commit('setshowImages', false);
        }

        if (itm === null) {
            commit('setItem', JSON.parse(JSON.stringify(state.deflt)));
            state.item.applicationUserId = rootState.account.loggedUser.id;
            state.item.applicationUser = {
                id: rootState.account.loggedUser.id,
                userName: rootState.account.loggedUser.userName,
                email: rootState.account.loggedUser.email
            };

        } else {
            // Miniaturas y rutas: mismo criterio que getById (system guarda + subDomain cliente+código)
            dispatch('getById', itm.id);
        }
        commit('setDialog', true);
        commit('setshowImages', true);
    },

    valida({ state, dispatch, commit }, completa) {
        return true;
    },

    setDialog({ commit }, payload) {
        commit('setDialog', payload);
    },

    setshowImages({ commit }, payload) {
        commit('setshowImages', payload);
    },

    closeDialog({ commit }) {
        commit('setDialog', false);
        commit('setshowImages', false);
    },

    tramitesCompletados() {
        let self = this;
        state.todosTramitesCompletados =
            state.item.guardaTramite.find(
                x =>
                    x.completado == false &&
                    x.tramiteId >= self.state.TRAMITES.INICIAGUARDA &&
                    self.state.tramite.items.find(l => l.id == x.tramiteId).modulo & 8 == 8
            ) == null;
    },

    getAll({ dispatch, commit, state }) {
        commit('getAllRequest');

        service.getAll().then(
            registro => commit('getAllSuccess', registro),
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch('alert/errorTime', error.message, {
                        root: true
                    });
                }
            }
        );
    },

    getFile({ commit, dispatch, state }, params) {
        //commit('getFileRequest')
        service.getFile(buildImageApiPayload(state.item, params.folder), params.file).then(
            registro => commit('getFileSuccess', registro),
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch('alert/errorTime', error.message, {
                        root: true
                    });
                }
            }
        );
    },

    getFilePath({ commit, state }, params) {
        var endpoint = service.getAPIServer();

        commit('getFilePathRequest', {
            "endpoint": endpoint,
            "domain": state.item.nombre,
            "subDomain": getImageSubDomain(state.item),
            "folder": params.folder,
            "file": params.file,
            "system": "guarda"
        });
    },

    fileUpload: async ({ commit, dispatch, state }, params) => {
        const endpoint = service.getAPIServer();

        if (params.files.length > 0) {
            for (const file of params.files) {
 
                // 📌 CONVERSIÓN A BASE64 CON MIME
                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                    reader.readAsDataURL(file.stream); // `stream` es el Blob/File original
                });

                commit('fileUploadRequest', {
                    endpoint,
                    domain: params.domain,
                    subDomain: params.subDomain,
                    folder: params.folder,
                    system: 1,
                    file,
                    base64
                });

                await service.UploadFile(file.name, {
                    ...state.uploadParams,
                    imgStream: base64
                }).then(() => {
                    const thumbPayload = buildImageApiPayload(state.item, params.folder);
                    if (params.folder === "fotos") dispatch('getThumbnails', thumbPayload);
                    else if (params.folder === "documentosCia") dispatch('getDocThumbnails', thumbPayload);
                    else if (params.folder === "privado") dispatch('getPrivThumbnails', thumbPayload);
                }).catch(error => {
                    commit('failure', error);
                    if (error.response && error.response.status === 401) {
                        dispatch('alert/errorTime', 'Error de permisos o sesión expirada!', { root: true });
                        router.push({ name: 'login' });
                    } else {
                        dispatch('alert/errorTime', error.message, { root: true });
                    }
                });
            }
        }
    },

    filePreUpload({ commit, dispatch, state }, params) {
        const endpoint = service.getAPIServer();

        // Solo continuar si hay archivos y path definido
        if (params.length > 0) {
            params.forEach(file => {

                commit('uploadThumbnailsRequest', file);

            });
        }
    },

    docFilePreUpload({ commit, dispatch, state }, params) {
        const endpoint = service.getAPIServer();

        // Solo continuar si hay archivos y path definido
        if (params.length > 0) {
            params.forEach(file => {

                commit('uploadDocThumbnailsRequest', file);

            });
        }
    },

    privFilePreUpload({ commit, dispatch, state }, params) {
        const endpoint = service.getAPIServer();

        // Solo continuar si hay archivos y path definido
        if (params.length > 0) {
            params.forEach(file => {

                commit('uploadPrivThumbnailsRequest', file);

            });
        }
    },

    getThumbnails({ dispatch, commit, state }, payload) {

        commit('getThumbnailsRequest', payload);

        if (!canFetchGuardaImageApi(payload)) {
            if (payload.domain) {
                dispatch(
                    'alert/errorTime',
                    'No se pueden cargar miniaturas: indique cliente (abreviatura) y código en el registro.',
                    { root: true }
                );
            }
            commit('getThumbnailsSuccess', []);
            return;
        }

        service.getThumbnails(payload).then(
            registro => {
                if (registro.data != null)
                    commit('getThumbnailsSuccess', registro.data.entries)
            },
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch(
                        'alert/errorTime',
                        getRequestErrorMessage(error, 'No se pudieron cargar las miniaturas.'),
                        { root: true }
                    );
                }
            }
        );
    },

    getDocThumbnails({ dispatch, commit, state }, payload) {
        commit('getDocThumbnailsRequest', payload);

        if (!canFetchGuardaImageApi(payload)) {
            if (payload.domain) {
                dispatch(
                    'alert/errorTime',
                    'No se pueden cargar miniaturas de documentos: indique cliente (abreviatura) y código en el registro.',
                    { root: true }
                );
            }
            commit('getDocThumbnailsSuccess', []);
            return;
        }

        service.getThumbnails(payload).then(
            registro => {
                if (registro.data != null)
                    commit('getDocThumbnailsSuccess', registro.data.entries)
            },
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch(
                        'alert/errorTime',
                        getRequestErrorMessage(error, 'No se pudieron cargar las miniaturas de documentos.'),
                        { root: true }
                    );
                }
            }
        );
    },

    getPrivThumbnails({ dispatch, commit, state }, payload) {
        commit('getPrivThumbnailsRequest', payload);

        if (!canFetchGuardaImageApi(payload)) {
            if (payload.domain) {
                dispatch(
                    'alert/errorTime',
                    'No se pueden cargar miniaturas (privado): indique cliente (abreviatura) y código en el registro.',
                    { root: true }
                );
            }
            commit('getPrivThumbnailsSuccess', []);
            return;
        }

        service.getThumbnails(payload).then(

            registro => {
                if (registro.data != null)
                    commit('getPrivThumbnailsSuccess', registro.data.entries)
            },
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch('alert/errorTime', error.message, {
                        root: true
                    });
                }
            }
        );
    },

    getCompact({ dispatch, commit, state, rootState }) {
        var self = this;
        commit('getAllRequest');

        return service.getCompact({
            clientes: rootState.account.loggedUser.userClientes,
            finalizados: true,
            applicationUserId: rootState.account.loggedUser.id,
            itemsPerPage: 0,
            page: 0
        }).then(
            registro => commit('getCompactSuccess', { registro, self }),
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch('alert/errorTime', error.message, {
                        root: true
                    });
                }
            }
        );
    },

    async getCompactAsync({ dispatch, commit, state, rootState }) {
        var self = this;
        commit('getAllRequest');
        try {
            commit('getCompactSuccess', await service.getCompactAsync({
                clientes: rootState.account.loggedUser.userClientes,
                finalizados: true,
                applicationUserId: rootState.account.loggedUser.id,
                itemsPerPage: 0,
                page: 0
            }));
        }
        catch (error) {
            commit('failure', error);
            if (error.response && error.response.status == 401) {
                dispatch(
                    'alert/errorTime',
                    'Error de permisos o sesión expirada!',
                    {
                        root: true
                    }
                );
                router.push({ name: 'login' });
            } else {
                dispatch('alert/errorTime', error.message, {
                    root: true
                });
            }
        }
    },

    getCompactPaging({ dispatch, commit, rootState }, payLoad) {
        var self = this;

        commit('getAutocompleteRequest');
        if (obj.value != undefined) {
            service.getAutocomplete(obj).then(
                registro => commit('getAutocompleteSuccess', registro),
                error => {
                    commit('failure', error);
                    if (error.response && error.response.status == 401) {
                        dispatch(
                            'alert/errorTime',
                            'Error de permisos o sesión expirada!',
                            {
                                root: true
                            }
                        );
                        router.push({ name: 'login' });
                    } else {
                        dispatch('alert/errorTime', error.message, {
                            root: true
                        });
                    }
                }
            );
        }
    },

    getById({ dispatch, commit, state }, id) {
        var self = this;

        commit('getByRequest');

        service.getById(id).then(
            registro => {
                // Filtra observaciones internas si es compañia o productor
                registro.guardaTramite = registro.guardaTramite.filter(
                    x =>
                        self.state.account.permisos.guardaEdita ||
                        (!self.state.account.permisos.guardaEdita &&
                            x.tramiteId !=
                            self.state.TRAMITES.OBSERVACION_INTERNA)
                );

                registro.guardaTramite.map((val, index) => (val.orden = index));

                commit('getBySuccess', registro);

                dispatch('getThumbnails', buildImageApiPayload(registro, 'fotos'));
                dispatch('getDocThumbnails', buildImageApiPayload(registro, 'documentosCia'));
                dispatch('getPrivThumbnails', buildImageApiPayload(registro, 'privado'));
                // Completa orden
                //service.orderTramites(state.item);
                dispatch('setState');
            },
            error => {
                commit('failure', error);
                if (error.response && error.response.status == 401) {
                    dispatch(
                        'alert/errorTime',
                        'Error de permisos o sesión expirada!',
                        {
                            root: true
                        }
                    );
                    router.push({ name: 'login' });
                } else {
                    dispatch(
                        'alert/errorTime',
                        getRequestErrorMessage(error, 'No se encontro la guarda o esta borrada.'),
                        { root: true }
                    );
                }
            }
        );
    },

    setModificado({ state }, val) {
        state.modificado = val;
    },

    setState({ state, rootGetters }) {
        var tramites = service.orderTramites(state.item);
        var self = this;

        // Si hay mas anulados que reactivados pone en estado anulado
        if (service.anulado(tramites) != 0) {
            state.item.estadoId = 2; // Anulado
            state.item.estado = self.state.estado.all.items[1];
        } else {
            // busca el estado filtrando observaciones, anulados y reactivados y
            // tramites que no tengas estados inicial y final indeterminados,
            // si no hay tramites pone sininiciar
            var tmtes = tramites.filter(x => {
                var tm = rootGetters['tramite/getTramiById'](x.tramiteId);
                var ret = (tm.estadoInicialId > 2 || tm.estadoFinalId > 2) && ((tm.modulo & 8) == 8);
                return ret;
            });

            //var t = rootGetters["tramite/getTramiById"](1);
            //t = rootGetters["tramite/getTramiById"](1001);
            var tmt = 0;

            // Si no hay tramites asigna TRAMITES.SIN_INICIAR
            if (tmtes.length == 0) {
                state.item.estadoId = self.state.ESTADOS.SIN_INICIAR;
                state.item.estado = self.state.estado.all.items.find(
                    x => x.id == self.state.ESTADOS.SIN_INICIAR
                );
            } else {
                tmtes.map(function (val) {
                    if (tmt == 0) {
                        //if (tmt < val.tramiteId) {
                        tmt = val.tramiteId;
                        if (!val.completado) {
                            var tr = self.state.tramite.items.find(
                                x => x.id == tmt
                            );
                            state.item.estadoId = tr.estadoInicialId;
                            state.item.estado = tr.estadoInicial;
                        } else {
                            var tr1 = self.state.tramite.items.find(
                                x => x.id == tmt
                            );
                            state.item.estadoId = tr1.estadoFinalId;
                            state.item.estado = tr1.estadoFinal;
                        }
                    } 
                });
            }
        }
        if (state.item.estadoId == self.state.ESTADOS.FINALIZADO) {
            state.item.deposito = { id: 0, nombre: "" };
            state.item.depositoId = null;
            state.item.puestoId = null;
        } else {
            service.setDepositoPuesto(state.item);
        }
    },

    //getxyyyy({ commit }, yyyyId) {
    //    commit('getAllRequest');

    //    service
    //        .getxyyyy(yyyyId)
    //        .then(
    //            registro => commit('getAllSuccess', registro),
    //            error => commit('failure', error)
    //        );
    //},

    saveItem({ dispatch, commit, state }) {
        const doUpload = () => {
            state.newThumbnails.forEach(file => {
                dispatch('fileUpload', {
                    files: [{ name: file.name, stream: file.file }],
                    folder: 'fotos',
                    system: 1,
                    domain: file.domain,
                    subDomain: file.subDomain
                });
            });
            state.newThumbnails = [];
            state.newDocThumbnails.forEach(file => {
                dispatch('fileUpload', {
                    files: [{ name: file.name, stream: file.file }],
                    folder: 'documentosCia',
                    system: 1,
                    domain: file.domain,
                    subDomain: file.subDomain
                });
            });
            state.newDocThumbnails = [];
            state.newPrivThumbnails.forEach(file => {
                dispatch('fileUpload', {
                    files: [{ name: file.name, stream: file.file }],
                    folder: 'privado',
                    system: 1,
                    domain: file.domain,
                    subDomain: file.subDomain
                });
            });
            state.newPrivThumbnails = [];
        };

        if (state.item.id > 0) {
            dispatch('putObject').then(doUpload);
        } else {
            dispatch('postObject').then(doUpload);
        }

        commit('setDialog', false);
        commit('setshowImages', false);
    },

    setDialog({ commit }, payload) {
        commit('setDialog', payload);
    },

    setshowImages({ commit }, payload) {
        commit('setshowImages', payload);
    },

    setBorraDialog({ commit }, payload) {
        commit('setBorraDialog', payload);
    },

    setDialogTramite({ commit }, payload) {
        commit('setDialogTramite', payload);
    },

    postObject({ dispatch, commit, state }) {
        commit('postRequest', state.item);

        state.item.applicationUserId = this._modules.root.state.account.loggedUser.id;

        return service.postObject(state.item).then(
            registro => {
                commit('postSuccess', registro);
            },
            error => {
                dispatch('alert/errorTime', error.response.data, { root: true });
                return Promise.reject(error);
            }
        );
    },

    putObject({ dispatch, commit, state }) {
        commit('putRequest', state.item);

        state.item.applicationUserId = this._modules.root.state.account.loggedUser.id;

        return service.putObject(state.item).then(
            registro => {
                commit('putSuccess', registro);
            },
            error => {
                dispatch('alert/errorTime', error.response.data, { root: true });
                return Promise.reject(error);
            }
        );
    },

    deleteItem({ commit }, id) {
        commit('deleteRequest', id);

        service.deleteObject(id).then(
            campoTramite => commit('deleteSuccess', id),
            error => commit('failure', { id, error: error.toString() })
        );
    },

    exportaGuardas({ dispatch, commit, state }) {
        commit('exportaGuardasRequest');

        service.guardasExporta().then(
            response => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'guardas.xls');
                document.body.appendChild(fileLink);

                fileLink.click();
                commit('exportaGuardasSuccess');
            },
            error => {
                commit('failure', error);
                state.error = true;
                dispatch('alert/errorTime', error.message, {
                    root: true
                });
            }
        );
    },

    closeDialog({ commit }) {
        commit('setDialog', false);
    },

    closeBorraDialog({ commit }) {
        commit('setBorraDialog', false);
    },

    closeDialogTramite({ commit }) {
        commit('setDialogTramite', false);
    },

    setItem({ commit }, payload) {
        commit('setItem', payload);
    },


    editTramite({ dispatch, commit }, itm) {
        if (this.state.account.permisos.guardaCliente) {
            const tramite = JSON.parse(JSON.stringify(itm));
            tramite.nuevoTramite = false;

            if (isGuardaDestinoTramite(tramite.tramiteId, this.state.TRAMITES)) {
                setGuardaDestino(tramite, state.item, this.state.deposito.items);
            }

            dispatch('setTramite', tramite);
            commit('setDialogTramite', true);
        }
    },

    newTramite({ dispatch, commit }, tramiteId) {
        var tmt = state.item.guardaTramite.find(x => x.tramiteId == tramiteId);
        if (tramiteId >= this.state.TRAMITES.INICIABAJA && tramiteId != this.state.TRAMITES.TRASLADO && tmt != null) {
            dispatch('editTramite', tmt);
        } else {
            var nt = JSON.parse(JSON.stringify(state.defltTramite));
            nt.orden = state.item.guardaTramite.length;
            nt.nuevoTramite = true;
            nt.tramiteId = tramiteId;
            nt.completado = false;
            nt.usuario = 0;

            if (isGuardaDestinoTramite(tramiteId, this.state.TRAMITES)) {
                setGuardaDestino(nt, state.item, this.state.deposito.items);
            }

            dispatch('setTramite', nt);
            commit('setDialogTramite', true);
        }
    },

    setTramite({ commit }, payload) {
        commit('setTramite', payload);
    },

    pushChild({ commit }, payload) {
        commit('pushChild', payload);
    },

};

const mutations = {
    // GetAll
    getAllRequest(state) {
        state.items = [];
        state.progress = true;
    },

    getAllSuccess(state, registro) {
        state.items = registro;
        state.progress = false;
    },

    getThumbnailsRequest(state, payload) {
        payload.endpoint = service.getAPIServer();
        state.thumbnails = [];
        state.newThumbnails = [];
    },

    getDocThumbnailsRequest(state, payload) {
        payload.endpoint = service.getAPIServer();
        state.docThumbnails = [];
        state.newDocThumbnails = [];
    },

    getPrivThumbnailsRequest(state, payload) {
        payload.endpoint = service.getAPIServer();
        state.privThumbnails = [];
        state.newPrivThumbnails = [];
    },

    getFilePathRequest(state, payload) {
        payload.domain = payload.domain
            .replace(/[/\\]/g, '')  // Elimina '/' y '\'
            .replace(/\s+/g, '');   // Elimina espacios
        payload.subDomain = payload.subDomain
            .replace(/[/\\]/g, '')  // Elimina '/' y '\'
            .replace(/\s+/g, '');   // Elimina espacios

        state.filePath = payload.endpoint + "download-file/" + payload.system + "/" + payload.domain + "-" + payload.subDomain + "/" + payload.folder + "/" + payload.file;
    },

    uploadThumbnailsRequest(state, payload) {
        state.newThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
    },

    uploadDocThumbnailsRequest(state, payload) {
        state.newDocThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
    },

    uploadPrivThumbnailsRequest(state, payload) {
        state.newPrivThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
    },

    fileToBase64(file) { return new Promise(r => { const fr = new FileReader(); fr.onload = () => r(fr.result); fr.readAsDataURL(file); }) },

    fileUploadRequest(state, payload) {
        payload.domain = String(payload.domain ?? '')
            .replace(/[/\\]/g, '')
            .replace(/\s+/g, '');
        payload.subDomain = String(payload.subDomain ?? '')
            .replace(/[/\\]/g, '')
            .replace(/\s+/g, '');
        payload.clienteAbrv = (payload.clienteAbrv != null ? String(payload.clienteAbrv) : '')
            .replace(/[/\\]/g, '')
            .replace(/\s+/g, '');
        payload.codigo = (payload.codigo != null ? String(payload.codigo) : '')
            .replace(/[/\\]/g, '')
            .replace(/\s+/g, '');
        payload.fileName = payload.file.name.replace(/[/\\]/g, '').replace(/\s+/g, '');

        state.uploadFilePath =
            payload.endpoint +
            "upload-file/" +
            payload.system + "/" +
            payload.domain + "-" +
            payload.subDomain + "/" +
            payload.folder;

        state.uploadParams = {
            domain: payload.domain,
            subDomain: payload.subDomain,
            system: payload.system,
            folder: payload.folder,
            clienteAbrv: payload.clienteAbrv,
            codigo: payload.codigo,
            imgStream: payload.base64 // 📌 Ya viene lista
        };
    },

    getThumbnailsSuccess(state, registro) {
        state.thumbnails = registro;
        state.progress = false;
    },

    getFileSuccess(state, registro) {
        state.file = registro;
        state.progress = false;
    },

    getDocThumbnailsSuccess(state, registro) {
        state.docThumbnails = registro;
        state.progress = false;
    },

    getPrivThumbnailsSuccess(state, registro) {
        state.privThumbnails = registro;
        state.progress = false;
    },


//    if(state.item.id > 0) {
//        dispatch('putObject').then(doUpload);
//        } else {
//    dispatch('postObject').then(doUpload);
//}

//commit('setDialog', false);
//commit('setshowImages', false);
//    },

failure(state, error) {
    state.id = 0;
    state.progress = false;
    state.error = error;
},

setRelation() {

},

getCompactSuccess(state, payload) {
    let self = this;
    state.items = payload.registro.map(function (item) {

        var rec = self.state.estado.all.items.find(x => x.id == item.estadoId);

        if (rec != undefined) {
            item.estado = rec;
        } else {
            item.estado = null;
        }
        return item;

        var rec = self.state.cliente.items.find(x => x.id == item.clienteId);
        if (rec != undefined) {
            item.cliente = rec.nombre;
        } else {
            item.cliente = null;
        }

    });
    state.progress = false;
},

// Post
postRequest(state) {
    state.progress = true;
},

// GetBy
getByRequest(state) {
    state.item = JSON.parse(JSON.stringify(state.deflt));
    state.id = 0;
    state.progress = true
    state.processed = false
    state.error = false
},

getBySuccess(state, registro) {
    state.item = registro;
    if (registro.modeloValor == null || registro.modeloValor == '')
        state.marcaModelo = registro.marca.nombre + ' ' + registro.modelo.nombre;
    state.modificado = false;

    state.item.detalles = [];
    state.item.detalles1 = [];
    state.id = registro.id;
    state.progress = false;
},

postSuccess(state, registro) {
    var reg = {};
    let al = registro.guardaAlerta.find(x => x.alertaId == 1 || x.alertaId == 2);
    if (al) {
        reg.alerta = al.alertaId;
        reg.fAlerta = al.fInicio;
        reg.dAlerta = al.descripcion;
    }
    else {
        reg.alerta = 0;
        reg.fAlerta = null;
        reg.dAlerta = null;
    }

    let self = this;

    reg.id = registro.id;
    reg.tramite = registro.guardaTramite.map(function (itm) {
        var tmt = self.state.tramite.items.find(x => x.id == itm.tramiteId);

        if ((tmt.modulo & 8) == 8 && itm.completado) {
            return itm.tramiteId;
        }
    });

    reg.fInicio = registro.fInicio
    reg.tramite = reg.tramite.filter(x => x != undefined);
    reg.codigo = registro.codigo;
    reg.cliente = registro.cliente.nombre;
    reg.dominio = registro.nombre;
    reg.siniestro = registro.siniestro;
    reg.marca = registro.marca.nombre;
    reg.modelo = registro.modelo.nombre;
    reg.clienteId = registro.clienteId;
    reg.estado = self.state.estado.all.items.find(x => x.id == registro.estado.id);
    reg.color = registro.color;
    reg.dropboxLink = registro.dropboxLink;
    reg.codigo = registro.sCodigo;

    if (registro.modeloValorId != null && registro.modeloValorId != '') {
        var rec = this.state.modelovalor.items.find(x => x.modeloValorId == registro.modeloValorId);
        if (rec != undefined) {
            reg.marcaModelo = rec.marca + ' ' + rec.modelo;
        }
    } else {
        reg.marcaModelo = registro.marca.nombre + ' ' + registro.modelo.nombre;
    }

    if (registro.depositoId === null)
        reg.depositoPuesto = '';
    var dep = this.state.deposito.items.find(x => x.id == registro.depositoId);
    if (dep) {
        reg.depositoPuesto = dep.nombre + ((registro.puestoId != null) ? (' / ' + registro.puestoId) : '');
    }
    state.items.push(reg);
    state.item = registro;
    state.progress = false;
},

// Put
putRequest(state) {
    state.progress = true;
},

putSuccess(state, registro) {
    var reg = {};
    let al = registro.guardaAlerta.find(x => x.alertaId == 1 || x.alertaId == 2);
    if (al) {
        reg.alerta = al.alertaId;
        reg.fAlerta = al.fInicio;
        reg.dAlerta = al.descripcion;
    }
    else {
        reg.alerta = 0;
        reg.fAlerta = null;
        reg.dAlerta = null;
    }

    let self = this;
    var i = state.items.find(x => x.id == registro.id);
    var index = state.items.indexOf(i);

    reg.id = registro.id;
    reg.tramite = registro.guardaTramite.map(function (itm) {
        var tmt = self.state.tramite.items.find(x => x.id == itm.tramiteId);

        if ((tmt.modulo & 8) == 8 && itm.completado) {
            return itm.tramiteId;
        }
    });

    reg.fInicio = registro.fInicio

    reg.tramite = reg.tramite.filter(x => x != undefined);
    reg.codigo = registro.codigo;
    reg.cliente = registro.cliente.nombre;
    reg.dominio = registro.nombre;
    reg.siniestro = registro.siniestro;
    reg.marca = registro.marca.nombre;
    reg.modelo = registro.modelo.nombre;
    reg.clienteId = registro.clienteId;
    reg.estado = self.state.estado.all.items.find(x => x.id == registro.estado.id);
    reg.color = registro.color;
    reg.dropboxLink = registro.dropboxLink;
    reg.codigo = registro.sCodigo;

    //if (registro.modeloValorId != null && registro.modeloValorId != '') {
    //    var rec = this.state.modelovalor.items.find(x => x.modeloValorId == registro.modeloValorId);
    //    if (rec != undefined) {
    //        reg.marcaModelo = rec.marca + ' ' + rec.modelo;
    //    }
    //} else {
    //    reg.marcaModelo = registro.marca.nombre + ' ' + registro.modelo.nombre;
    //}

    if (registro.depositoId === null)
        reg.depositoPuesto = '';
    var dep = this.state.deposito.items.find(x => x.id == registro.depositoId);
    if (dep) {
        reg.depositoPuesto = dep.nombre + ((registro.puestoId != null) ? (' / ' + registro.puestoId) : '');
    }

    state.items.splice(index, 1, JSON.parse(JSON.stringify(reg)));

    state.progress = false;
},

deleteRequest(state, id) {
    state.progress = true;
    // add 'deleting:true' property to campoTramite being deleted
    state.items = state.items.map(campoTramite =>
        campoTramite.id === id
            ? { ...campoTramite, deleting: true }
            : campoTramite
    );
},

deleteSuccess(state, id) {
    // remove deleted campoTramite from state
    state.items = state.items.filter(
        campoTramite => campoTramite.id !== id
    );
    state.progress = false;
},

exportaGuardasRequest(state) {
    state.progress = true;
},

exportaGuardasSuccess(state) {
    state.progress = false;
},

setDialog(state, payload) {
    state.dialog = payload;
    if (payload == false) {
        state.item = JSON.parse(JSON.stringify(state.deflt));
    }
},

setDialogTramite(state, payload) {
    state.dialogTramite = payload;
},

setshowImages(state, payload) {
    state.showImages = payload;
},

setItem(state, payload) {
    state.item = payload;
    if (payload.id == 0) {
        state.id = 0;
    }
},

setTramite(state, payload) {
    state.tramite = payload;
},

//setDepositoPuesto(state, payload) {
//    state.item.deposito = this.state.deposito.find(x => x.id == payload);
//},

pushChild(state, payload) {
    state.item.guardaTramite.push(payload);
},

getThumbnailsRequest(state, payload) {
    payload.endpoint = service.getAPIServer();
    state.thumbnails = [];
    state.newThumbnails = [];
},

getDocThumbnailsRequest(state, payload) {
    payload.endpoint = service.getAPIServer();
    state.docThumbnails = [];
    state.newDocThumbnails = [];
},

getPrivThumbnailsRequest(state, payload) {
    payload.endpoint = service.getAPIServer();
    state.privThumbnails = [];
    state.newPrivThumbnails = [];
},

getFilePathRequest(state, payload) {
    payload.domain = payload.domain
        .replace(/[/\\]/g, '')  // Elimina '/' y '\'
        .replace(/\s+/g, '');   // Elimina espacios
    payload.subDomain = payload.subDomain
        .replace(/[/\\]/g, '')  // Elimina '/' y '\'
        .replace(/\s+/g, '');   // Elimina espacios

    state.filePath = payload.endpoint + "download-file/" + payload.system + "/" + payload.domain + "-" + payload.subDomain + "/" + payload.folder + "/" + payload.file;
},

uploadThumbnailsRequest(state, payload) {
    state.newThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
},

uploadDocThumbnailsRequest(state, payload) {
    state.newDocThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
},

uploadPrivThumbnailsRequest(state, payload) {
    state.newPrivThumbnails.push(payload); // ahora guardamos todo el objeto, no solo el string
},

fileToBase64(file) { return new Promise(r => { const fr = new FileReader(); fr.onload = () => r(fr.result); fr.readAsDataURL(file); }) },

fileUploadRequest(state, payload) {
    payload.domain = String(payload.domain ?? '')
        .replace(/[/\\]/g, '')
        .replace(/\s+/g, '');
    payload.subDomain = String(payload.subDomain ?? '')
        .replace(/[/\\]/g, '')
        .replace(/\s+/g, '');
    payload.clienteAbrv = (payload.clienteAbrv != null ? String(payload.clienteAbrv) : '')
        .replace(/[/\\]/g, '')
        .replace(/\s+/g, '');
    payload.codigo = (payload.codigo != null ? String(payload.codigo) : '')
        .replace(/[/\\]/g, '')
        .replace(/\s+/g, '');
    payload.fileName = payload.file.name.replace(/[/\\]/g, '').replace(/\s+/g, '');

    state.uploadFilePath =
        payload.endpoint +
        "upload-file/" +
        payload.system + "/" +
        payload.domain + "-" +
        payload.subDomain + "/" +
        payload.folder;

    state.uploadParams = {
        domain: payload.domain,
        subDomain: payload.subDomain,
        system: payload.system,
        folder: payload.folder,
        clienteAbrv: payload.clienteAbrv,
        codigo: payload.codigo,
        imgStream: payload.base64 // 📌 Ya viene lista
    };
},

getThumbnailsSuccess(state, registro) {
    state.thumbnails = registro;
    state.progress = false;
},

};

export const guarda = {
    namespaced: true,
    state,
    actions,
    mutations
};
